import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {BuildingCreateReq, Building, BuildingUpdateReq, Buildings} from '../types/building';
/**
 * BuildingServiceApi - axios parameter creator
 * @export
 */
export const BuildingServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 公寓楼创建
     * @summary 公寓楼创建
     * @param {BuildingCreateReq} buildingCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceCreate: async (
      buildingCreateReq: BuildingCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'buildingCreateReq' is not null or undefined
      assertParamExists('buildingServiceCreate', 'buildingCreateReq', buildingCreateReq);
      const localVarPath = `/building/building`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        buildingCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓楼删除
     * @summary 公寓楼删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('buildingServiceDelete', 'id', id);
      const localVarPath = `/building/building/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓楼详情
     * @summary 公寓楼详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('buildingServiceDetail', 'id', id);
      const localVarPath = `/building/building/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓楼查询
     * @summary 公寓楼查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceFind: async (
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/building/buildings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      if (apartmentIds) {
        localVarQueryParameter['apartmentIds'] = apartmentIds;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 公寓楼修改
     * @summary 公寓楼修改
     * @param {string} buildingId
     * @param {BuildingUpdateReq} buildingUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceUpdate: async (
      buildingId: string,
      buildingUpdateReq: BuildingUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'buildingId' is not null or undefined
      assertParamExists('buildingServiceUpdate', 'buildingId', buildingId);
      // verify required parameter 'buildingUpdateReq' is not null or undefined
      assertParamExists('buildingServiceUpdate', 'buildingUpdateReq', buildingUpdateReq);
      const localVarPath = `/building/building/{buildingId}`.replace(
        `{${'buildingId'}}`,
        encodeURIComponent(String(buildingId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        buildingUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BuildingServiceApi - functional programming interface
 * @export
 */
export const BuildingServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BuildingServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 公寓楼创建
     * @summary 公寓楼创建
     * @param {BuildingCreateReq} buildingCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buildingServiceCreate(
      buildingCreateReq: BuildingCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buildingServiceCreate(
        buildingCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BuildingServiceApi.buildingServiceCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓楼删除
     * @summary 公寓楼删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buildingServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buildingServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BuildingServiceApi.buildingServiceDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓楼详情
     * @summary 公寓楼详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buildingServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Building>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buildingServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BuildingServiceApi.buildingServiceDetail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓楼查询
     * @summary 公寓楼查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buildingServiceFind(
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Buildings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buildingServiceFind(
        orgId,
        ids,
        apartmentIds,
        name,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BuildingServiceApi.buildingServiceFind']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 公寓楼修改
     * @summary 公寓楼修改
     * @param {string} buildingId
     * @param {BuildingUpdateReq} buildingUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buildingServiceUpdate(
      buildingId: string,
      buildingUpdateReq: BuildingUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buildingServiceUpdate(
        buildingId,
        buildingUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BuildingServiceApi.buildingServiceUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BuildingServiceApi - factory interface
 * @export
 */
export const BuildingServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BuildingServiceApiFp(configuration);
  return {
    /**
     * 公寓楼创建
     * @summary 公寓楼创建
     * @param {BuildingCreateReq} buildingCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceCreate(
      buildingCreateReq: BuildingCreateReq,
      options?: any
    ): AxiosPromise<IdRsp> {
      return localVarFp
        .buildingServiceCreate(buildingCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓楼删除
     * @summary 公寓楼删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .buildingServiceDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓楼详情
     * @summary 公寓楼详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceDetail(id: string, options?: any): AxiosPromise<Building> {
      return localVarFp
        .buildingServiceDetail(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓楼查询
     * @summary 公寓楼查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceFind(
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options?: any
    ): AxiosPromise<Buildings> {
      return localVarFp
        .buildingServiceFind(orgId, ids, apartmentIds, name, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 公寓楼修改
     * @summary 公寓楼修改
     * @param {string} buildingId
     * @param {BuildingUpdateReq} buildingUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buildingServiceUpdate(
      buildingId: string,
      buildingUpdateReq: BuildingUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .buildingServiceUpdate(buildingId, buildingUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BuildingServiceApi - object-oriented interface
 * @export
 * @class BuildingServiceApi
 * @extends {BaseAPI}
 */
export class BuildingServiceApi extends BaseAPI {
  /**
   * 公寓楼创建
   * @summary 公寓楼创建
   * @param {BuildingCreateReq} buildingCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuildingServiceApi
   */
  public buildingServiceCreate(
    buildingCreateReq: BuildingCreateReq,
    options?: RawAxiosRequestConfig
  ) {
    return BuildingServiceApiFp(this.configuration)
      .buildingServiceCreate(buildingCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓楼删除
   * @summary 公寓楼删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuildingServiceApi
   */
  public buildingServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return BuildingServiceApiFp(this.configuration)
      .buildingServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓楼详情
   * @summary 公寓楼详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuildingServiceApi
   */
  public buildingServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return BuildingServiceApiFp(this.configuration)
      .buildingServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓楼查询
   * @summary 公寓楼查询
   * @param {string} [orgId]
   * @param {Array<string>} [ids]
   * @param {Array<string>} [apartmentIds]
   * @param {string} [name] search name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuildingServiceApi
   */
  public buildingServiceFind(
    orgId?: string,
    ids?: Array<string>,
    apartmentIds?: Array<string>,
    name?: string,
    options?: RawAxiosRequestConfig
  ) {
    return BuildingServiceApiFp(this.configuration)
      .buildingServiceFind(orgId, ids, apartmentIds, name, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 公寓楼修改
   * @summary 公寓楼修改
   * @param {string} buildingId
   * @param {BuildingUpdateReq} buildingUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuildingServiceApi
   */
  public buildingServiceUpdate(
    buildingId: string,
    buildingUpdateReq: BuildingUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return BuildingServiceApiFp(this.configuration)
      .buildingServiceUpdate(buildingId, buildingUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
